export const insertBetween = <T>(items: T[], separator: T): T[] => {
  const result: T[] = items[0] ? [items[0]] : []
  items.slice(1).forEach((item) => result.push(separator, item))

  return result
}
